import React from 'react';
import { SvgIcon, SvgIconProps } from '../../wag-react/next-components/icons';
import { theme } from '../../wag-react/themes/base-theme';
export type NormalIconProps = SvgIconProps;
export const NormalIcon = (props: NormalIconProps) => <SvgIcon viewBox="0 0 33 33" color={theme.colors.mySin} {...props} data-sentry-element="SvgIcon" data-sentry-component="NormalIcon" data-sentry-source-file="NormalIcon.tsx">
    <circle cx="16.5" cy="16.5" fill="currentColor" fillRule="evenodd" r="16.5" data-sentry-element="circle" data-sentry-source-file="NormalIcon.tsx" />
  </SvgIcon>;